import { Navigate } from 'react-router';

/**
 * ESKI "GELEN TEKLIFLER" ADRESI — /musteri/teklifler (2026-10-02'de menuden kaldirildi).
 *
 * Teklifler artik talebin kendi sayfasinda canli (/musteri/talepler/:taskId) ve ekranin tek
 * ozgun isi (org yoneticisine talep sahibinin adi) Taleplerim kartina tasindi. Yer imleri ve
 * eski baglantilar 404'e dusmesin diye rota duruyor ve Taleplerim'e yonlendiriyor. `replace`:
 * geri tusu kullaniciyi tekrar yonlendirmeye sokmasin.
 */
export function IncomingOffersRedirect() {
  return <Navigate to="/musteri/talepler" replace />;
}
